<div fxLayout="column" fxLayoutGap="15px">

    <text-input-ctrl [caption]="'admin-center.user.userName'" [formControlName]="'userName'" [settings]="{fxFill:true}">
    </text-input-ctrl>

    <text-input-ctrl [caption]="'admin-center.user.name'" [formControlName]="'name'"
        [settings]="{fxFill:true,firstLetterUpper:true}">
    </text-input-ctrl>

    <text-input-ctrl [caption]="'admin-center.user.surname'" [formControlName]="'surname'"
        [settings]="{fxFill:true,firstLetterUpper:true}">
    </text-input-ctrl>

    <text-input-ctrl [caption]="'admin-center.user.email'" [formControlName]="'email'" [settings]="{fxFill:true}">
    </text-input-ctrl>

    <masked-text-input-ctrl [caption]="'admin-center.user.phoneNumber'" [formControlName]="'phoneNumber'"
        [settings]="{format:'000 000 000',fxFill:true}"></masked-text-input-ctrl>


</div>